<template>
  <div class="bodycontain">
    <template v-if="infodata">
      <div class="outcontain">
        <div class="titletext">{{ iteminfo.title }}</div>
        <div class="itemcontain">
          <div class="itemleft">
            <div class="text">姓名:</div>
            <div class="text text2">
              {{ iteminfo.user_name }} / {{ iteminfo.student_sn }}
            </div>
            <!-- <div class="text"> </div> -->
          </div>
          <div class="itemright">
            <div class="text">实习形式:</div>
            <div class="text text2">{{ iteminfo.type | typeformat }}</div>
          </div>
        </div>
        <div class="itemcontain">
          <div class="itemleft">
            <div class="text">所在院系:</div>
            <div class="text text2">{{ iteminfo.college_name }}/</div>
            <div class="text">{{ iteminfo.major_name }}/</div>
            <div class="text">{{ iteminfo.class_name }}</div>
          </div>
          <div class="itemright">
            <div class="text">实习时间:</div>
            <div class="text text2">
              {{ iteminfo.start_date | dataformat }} ~
              {{ iteminfo.end_date | dataformat }}
            </div>
          </div>
        </div>
        <div class="itemcontain">
          <div class="itemleft">
            <div class="text">实习计划:</div>
            <div class="text text2">{{ iteminfo.plan_name }}</div>
          </div>
          <div class="itemright">
            <div class="text">总结时间:</div>
            <div class="text text2">{{ infodata.created_at | dataformat }}</div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">实习标题</div>
        <div class="contenttext">{{ infodata.title }}</div>
        <div class="title">实习内容</div>
        <div class="contenttext">
          <div class="mine_cont" v-html="infodata.content"></div>
        </div>
        <!-- 目前后端储存数据地址在调整,设计附件上传以及下载的部分都进行隐藏 v-if="false" -->
        <template v-if="Array.isArray(infodata.file)">
          <div class="downbt bt">附件：</div>
          <div class="downbt" v-for="(item, index) in infodata.file" :key="index">
            <div class="file">
              <!-- <el-image class="image" :src="fileIcon(item.ext)" fit="contain" /> -->
              <el-button type="text" class="name" @click="fileView(item)">{{ item.name }}</el-button>
            </div>
            <el-image class="elimage" :src="icon1" @click="fileView(item)" />
            <el-image class="elimage" :src="icon2" @click="fileDownload(item)" />
          </div>
        </template>
        <template v-else>
          <div class="downbt bt">附件：</div>
          <div class="downbt_name">{{ infodata.file }}</div>
        </template>
      </div>
    </template>

    <el-dialog :visible.sync="innerVisible" title="预览" width="80%" append-to-body :before-close="closeDialog">
      <template v-if="type == '视频'">
        <video class="video_view" ref="vueRef" :src="videoviewurl" controls controlslist="nodownload noplaybackrate"
          disablepictureinpicture @contextmenu.prevent="handleRMouse" width="100%" height="500" />
      </template>
      <template v-if="type == '图片'">
        <iframe class="iframe_cont" :src="imageviewurl" frameborder="0" ref="myiframe"></iframe>
      </template>
      <template v-if="type == '其他'">
        <!-- <div class="tip_con">
            <div class="icon">!</div>
            <div class="tip_tex">
              <p v-show="is_private==0">该文件暂时不支持在线预览，您可以下载后查看！</p>
              <p v-show="is_private!=0">该文件暂时不支持在线预览！</p>
            </div>
          </div>-->
        <iframe class="iframe_cont" :src="file_url" frameborder="0" ref="myiframe"></iframe>
      </template>
      <template v-if="type == 'PDF'">
        <!-- <div class="pdf_con">
            <md-contract :url="fileurl" :visible="contractVisable" :showBtns="true" @handleModal="close"></md-contract>
          </div>-->
        <iframe class="iframe_cont" :src="fileurl" frameborder="0" ref="myiframe"></iframe>
      </template>
      <div id="toolbar" :class="toolbar == false ? 'tool-box doc_1' : 'tool-box'" style="visibility: visible">
        <div class="line-bar1"></div>
        <div class="full-box" style="text-align: right">
          <a class="full-btn1" @click="screen">
            <i class="el-icon-full-screen" style="font-size: 17px" />
            <span style="margin-left: 4px">全屏</span>
          </a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Mainpage from "@/views/news/components/mainpage.vue";

import {
  get_report_deatil,
  getinfopracticestudentreport,
} from "@/api/practicestudentreport";
import { Base64 } from "js-base64";
import screenfull from "screenfull";
const typemap = ["自主报名", "集中安排"];

export default {
  name: "News",
  components: {
    Mainpage,
  },
  data() {
    return {
      icon1: require("@/assets/查看.png"),
      icon2: require("@/assets/下载.png"),
      infodata: {},
      iteminfo: {},
      id: "",
      practice_plan_id: "",
      student_id: "",

      filePreview: "", // 数据预览
      picturesPreview: "", // 多图预览
      fileTask: "", // 数据预埋
      type: "",
      is_private: "",
      videoviewurl: "",
      imageviewurl: "",
      imageviewurlList: [], // 图片数据
      isImg: ["jpg", "png", "jpeg", "gif", "webp"],
      isVideo: ["mp4", "avi", "flv"],
      fileicon1: require("@/assets/fileicon/files.png"),
      fileicon2: require("@/assets/fileicon/icon-PDF.png"),
      fileicon3: require("@/assets/fileicon/icon-word.png"),
      fileicon4: require("@/assets/fileicon/icon-video.png"),
      fileicon5: require("@/assets/fileicon/icon-img.png"),
      fileicon6: require("@/assets/fileicon/icon-node.png"),
      fileicon7: require("@/assets/fileicon/icon-audio.png"),
      fileicon8: require("@/assets/fileicon/icon-chapter.png"),
      fileicon9: require("@/assets/fileicon/rar.png"),
      fileicon10: require("@/assets/fileicon/single.png"),
      fileicon11: require("@/assets/fileicon/txt.png"),
      fileicon12: require("@/assets/fileicon/xlsx.png"),
      fileicon13: require("@/assets/fileicon/zip.png"),
      itemObj: {},
      fullscreen: false, //全屏
      toolbar: false,
      innerVisible: false, // 预览框
    };
  },
  filters: {
    typeformat(val) {
      return typemap[val];
    },
    dataformat(value) {
      if (!value) return "";
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  created() {
    const systemConfig = sessionStorage.getItem("systemConfig");
    const systemInfo = systemConfig ? JSON.parse(systemConfig) : {};
    if (systemInfo.file_preview_url) {
      this.filePreview = systemInfo.file_preview_url + "/onlinePreview?url="; // 数据预览
      this.picturesPreview =
        systemInfo.file_preview_url + "/picturesPreview?urls="; // 多图预览
      this.fileTask = systemInfo.file_preview_url + "/addTask?url="; // 数据预埋
    } else {
      this.filePreview =
        request_base_path.pro_url + "/file-preview/onlinePreview?url="; // 数据预览
      this.picturesPreview =
        request_base_path.pro_url + "/file-preview/picturesPreview?urls="; // 多图预览
      this.fileTask = request_base_path.pro_url + "/file-preview/addTask?url="; // 数据预埋
    }
  },
  methods: {
    initdata(item) {
      this.id = item.id;
      this.practice_plan_id = item.practice_plan_id;
      this.student_id = item.student_id ? item.student_id : "";
      this.initLogInfo();
      this.init_repoet_info();
    },
    initLogInfo() {
      const params = {
        id: this.id,
        practice_plan_id: this.practice_plan_id,
        student_id: this.student_id,
      };
      getinfopracticestudentreport(params).then((res) => {
        if (res.code === 0) {
          this.infodata = res.data;
          this.infodata.content = this.AutoCorrection(res.data.content);
          const files = res.data.file || [];
          files.forEach(element => {
            if (this.isImg.includes(element.ext)) {
              this.imageviewurlList.push(element.url)
            };
          });
        }
      });
    },
    // 循环修正数据与数据格式
    AutoCorrection(str) {
      const that = this;
      let newStr = str.replace(/[\r\n]/g, "").trim(); // 去与换行与前后空格
      newStr = newStr.replace(/\\/g, ""); // 去除反斜杠
      newStr = newStr.replace(/\s+/g, " "); // 去除多余空格
      // newStr = newStr.replace(/<p>(\s|\&nbsp\;| |　|\xc2\xa0)*<\/p>/ig, ""); // 去掉多余 P 标签
      // 判断是否有图片，如果有图片
      let isHavePic = newStr.includes("<img");
      if (isHavePic) {
        // 正则过滤出图片
        newStr.replace(/<img.+?>/gi, function (matchImg, captureImg) {
          // console.log("正则匹配所有图片并获取相应下标==>",matchImg, captureImg);
          // newStr = newStr.replace(match,""); // 清除图片
          let resImgSrc = ""; // 自定义变量接收图片
          matchImg.replace(
            /<img[^>]*src=['"]([^'"]+)[^>]*>/gi,
            function (matchSrc, captureSrc) {
              // console.log("正则匹配该图片并获取相应路径==>",matchSrc, captureSrc);
              resImgSrc = captureSrc.replace(
                "../uploads",
                that.$api.baseUrl + "/uploads"
              );
            }
          );
          // 在图片中插入点击事件并默认不展示
          let newImgStr = matchImg.replace(
            /<s?img[^>]*src=['"]([^'"]+)/gi,
            `<img src="${resImgSrc}" style="max-width:80%; margin: 4px;"`
          );
          newStr = newStr.replace(matchImg, newImgStr);
        });
      }
      // 判断是否有视频，如果有视频
      let isHaveMove = newStr.includes("<video");
      if (isHaveMove) {
        // 正则过滤出视频
        newStr.replace(
          /(<video[\s\S]*?>)[\s\S]*?(<\/video>)/gi,
          function (matchVideo, captureVideo) {
            // console.log("正则匹配所有视频并获取相应下标==>",matchVideo, captureVideo);
            // newStr = newStr.replace(matchVideo,""); // 清空视频
            let resMoveurl = ""; // 自定义变量接收视频
            matchVideo.replace(
              /<source [^>]*src=['"]([^'"]+)[^>]*>/gi,
              function (matchUrl, captureUrl) {
                // console.log("正则匹配该视频并获取相应路径==>",matchUrl, captureUrl);
                resMoveurl = captureUrl.replace(
                  "../uploads",
                  that.$api.baseUrl + "/uploads"
                );
              }
            );
            let newMoveStr = matchVideo.replace(
              /<s?video[\s\S]*?>[\s\S]*?<\/video>/gi,
              `<video controls="controls" style="max-width:80%; margin: 4px;"><source src="${resMoveurl}" type="video/mp4"/></video>`
            );
            newStr = newStr.replace(matchVideo, newMoveStr);
          }
        );
      }
      return newStr;
    },
    init_repoet_info() {
      const params = {
        practice_plan_id: this.practice_plan_id,
        student_id: this.student_id,
      };
      get_report_deatil(params).then((res) => {
        if (res.code === 0) {
          this.iteminfo = res.data;
        }
      });
    },
    fileIcon(val) {
      switch (val) {
        case "file":
          return this.fileicon1;

        case "pdf":
          return this.fileicon2;

        case ("word", "docx"):
          return this.fileicon3;

        case "mp4":
          return this.fileicon4;

        case ("png", "jpg"):
          return this.fileicon5;

        case "radio":
          return this.fileicon7;

        case "rar":
          return this.fileicon9;

        case "txt":
          return this.fileicon11;

        case "xlsx":
          return this.fileicon12;

        case "zip":
          return this.fileicon13;

        default:
          return this.fileicon10;
      }
    },
    async fileView(item) {
      this.resetFill();
      await this.getTask(item.url);
      this.is_private = item.is_private;
      if (this.isVideo.includes(item.ext)) {
        this.type = "视频";
        this.videoviewurl = item.url;
        this.toolbar = false;
      } else if (this.isImg.includes(item.ext)) {
        this.type = "图片";
        let len = this.imageviewurlList.length;
        for (let i = 0; i < this.imageviewurlList.length; i++) {
          if (this.imageviewurlList[i] == item.url) {
            let newArr = this.imageviewurlList.splice(i, len - i);
            let oldArr = this.imageviewurlList;
            this.imageviewurlList = [...newArr, ...oldArr];
            break;
          }
        }
        let url = this.imageviewurlList.join("|");
        this.imageviewurl = this.picturesPreview + encodeURIComponent(Base64.encode(url));
        this.toolbar = true;
      } else if (item.ext == "pdf") {
        this.type = "PDF";
        this.fileurl =
          this.filePreview + encodeURIComponent(Base64.encode(item.url));
        this.toolbar = true;
      } else {
        this.type = "其他";
        this.file_url =
          this.filePreview + encodeURIComponent(Base64.encode(item.url));
        this.toolbar = true;
      }
      this.itemObj = item;
      this.innerVisible = true;
    },
    resetFill() {
      this.imageviewurl = "";
      this.fileurl = "";
      this.file_url = "";
    },
    getTask(data) {
      this.fileTask + data;
    },
    closeDialog() {
      this.innerVisible = false;
      this.resetFill();
    },
    //全屏
    screen() {
      if (screenfull.isEnabled) {
        screenfull.toggle(this.$refs.myiframe);
      }
    },
    fileDownload(item) {
      const downloadElement = document.createElement("a");
      downloadElement.download = item.name; //设置下载的名称
      downloadElement.href = item.url; // 创建下载的链接
      downloadElement.style.display = "none"; // 隐藏的可下载链接
      document.body.appendChild(downloadElement); // 创建虚拟下载元素
      downloadElement.target = "_blank";
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },
  },
};
</script>
<style scoped lang="scss">
.bodycontain {
  .outcontain {
    padding: 30px;
    padding-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dedede;

    .titletext {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 700;
      color: #3a3a3a;
    }

    .itemcontain {
      margin-bottom: 20px;
      padding-left: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .itemleft {
        width: 70%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .itemright {
        width: 30%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .text {
          min-width: 80px;
        }
      }

      .text {
        font-size: 16px;
        font-weight: 400;
        color: #3a3a3a;
      }

      .text2 {
        margin-left: 10px;
      }
    }
  }

  .content {
    min-height: 300px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 20px;

    .title {
      width: 100%;
      line-height: 30px;
      font-size: 16px;
      text-indent: 2em;
      padding-bottom: 10px;
    }

    .contenttext {
      // padding: 20px;
      width: 100%;
      box-sizing: border-box;
      padding-left: 30px;
      padding-bottom: 20px;

      ::v-deep .mine_cont {
        width: 100%;

        img {
          max-width: 100% !important;
          max-height: 800px;
        }
      }
    }

    .downbt {
      margin-top: 15px;
      margin-left: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 35px;

      .file {
        display: flex;
        align-items: center;

        .image {
          width: 30px;
          height: 30px;
          margin: 5px;
        }
      }

      .elimage {
        margin-left: 10px;
        cursor: pointer;
        top: 13px;
        width: 15px;
      }

      .downbt_name {
        color: #3d84ff;
      }
    }

    .bt {
      font-size: 16px;
      font-weight: bold;
      color: #000;
    }
  }
}

@media screen and (max-width: 640px) {
  .bodycontain {
    .outcontain {
      // padding: 30px;
      // padding-top: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .titletext {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 700;
        color: #3a3a3a;
      }

      .itemcontain {
        margin-bottom: 10px;
        // padding-left: 20px;
        // display: flex;
        // justify-content: flex-start;
        // align-items: center;

        .itemleft {
          width: 100%;
          display: flex;
          flex-basis: 400px;
          justify-content: flex-start;
          align-items: center;
          line-height: 30px;
        }

        .itemright {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          line-height: 30px;

          .text {
            min-width: 80px;
          }
        }

        .text {
          font-size: 16px;
          font-weight: 400;
          color: #3a3a3a;
        }

        .text2 {
          margin-left: 10px;
        }
      }
    }

    .content {
      min-height: 300px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      margin-top: 20px;

      .title {
        width: 100%;
        line-height: 30px;
        font-size: 16px;
        text-indent: 2em;
        padding-bottom: 10px;
      }

      .contenttext {
        // padding: 20px;
        width: 100%;
        box-sizing: border-box;
        padding-left: 30px;
        padding-bottom: 20px;

        ::v-deep .mine_cont {
          width: 100%;

          img {
            max-width: 100% !important;
            max-height: 800px;
          }
        }
      }

      .downbt {
        margin-top: 15px;
        margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 35px;

        .file {
          display: flex;
          align-items: center;

          .image {
            width: 30px;
            height: 30px;
            margin: 5px;
          }
        }

        .elimage {
          margin-left: 10px;
          cursor: pointer;
          top: 13px;
          width: 15px;
        }

        .downbt_name {
          color: #3d84ff;
        }
      }

      .bt {
        font-size: 16px;
        font-weight: bold;
        color: #000;
      }
    }
  }
}

@media screen and (min-width: 1200px) {}
</style>
